<fieldset class="is-flex is-flex-direction-column is-gap-2">
  <div class="is-flex is-align-items-center gap-xs">
    <img
      class="logo"
      src="/assistance plus.png"
      alt="icone soins"
      height="48"
      width="48" />
    <h3>{{ 'tarificateur.assistanceplus' | translate }}</h3>
  </div>
  <p>{{ 'tarificateur.assistancepluswish' | translate }}</p>
  <mat-radio-group
    [formControl]="fc"
    class="is-flex gap-s">
    <mat-radio-button class="is-flex-grow-1 tarif-option" [value]="1">
      <span class="is-size-6">{{ 'key.yes' | translate }}</span>
    </mat-radio-button>
    <mat-radio-button class="is-flex-grow-1 tarif-option" [value]="0">
      <span class="is-size-6">{{'key.no' | translate }}</span>
    </mat-radio-button>
  </mat-radio-group>
  @if (expanded) {
    <div class="option-detail">
      <div class="option-detail-info">
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.medical_evacuation.title' | translate }}</span> <span></span>
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.medical_evacuation.hospitalisation_fee.title' | translate }}</span>
        <span [innerHTML]="'tarificateur.option.assistanceplus.medical_evacuation.hospitalisation_fee.description' | translate"></span>
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.medical_evacuation.transport_fee.title' | translate }}</span>
        <span [innerHTML]="'tarificateur.option.assistanceplus.medical_evacuation.transport_fee.description' | translate"></span>
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.medical_evacuation.child_guard_fee.title' | translate }}</span>
        <span [innerHTML]="'tarificateur.option.assistanceplus.medical_evacuation.child_guard_fee.description' | translate"></span>
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.premature_return.title' | translate }}</span>
        <span [innerHTML]="'tarificateur.option.assistanceplus.premature_return.description' | translate"></span>
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.corpse_transport.title' | translate }}</span>
        <span [innerHTML]="'tarificateur.option.assistanceplus.corpse_transport.description' | translate"></span>
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.funeral_fee.title' | translate }}</span>
        <span [innerHTML]="'tarificateur.option.assistanceplus.funeral_fee.description' | translate"></span>
        <span class="option-detail-info-label">{{ 'tarificateur.option.assistanceplus.psychological_support.title' | translate }}</span>
        <span [innerHTML]="'tarificateur.option.assistanceplus.psychological_support.description' | translate"></span>

        <span class="option-detail-info-link"><a [href]="guaranteesTableLink" target="_blank">{{ 'tarificateur.option.guarantees_table_link' | translate }}</a></span>
      </div>
    </div>
  }
  <div class="width-full is-flex is-justify-content-center">
    <acs-expand-button [expanded]="expanded" (expandClick)="expandPanel()"></acs-expand-button>
  </div>
</fieldset>
